import { FC, useMemo } from 'react';

import { IHighlightedSpeaker } from '@/resources/ThinLecture';

import { TagHighlight } from './TagHighlight';

interface IHighlightedResultsProps<T extends Record<string, any>> {
  data: Array<T>;
  /**
   * Function should be stable, which means it should be defined outside component function or wrapped in
   * useCallback.
   */
  sort: (a: T, b: T) => number;
  /**
   * Function should be stable, which means it should be defined outside component function or wrapped in
   * useCallback.
   */
  getValue: (val: T) => string;
}

export const HighlightedResults: FC<IHighlightedResultsProps<IHighlightedSpeaker>> = ({ data, sort, getValue }) => {
  const hightlightString = useMemo(() => {
    return data?.sort(sort).map(getValue).join(', ');
  }, [data, sort, getValue]);

  return <TagHighlight htmlString={hightlightString} />;
};
